import React from "react";
import { Heading } from "react-aria-components";
import { t } from "ttag";

import type { ImageChooserBlockList } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { CenteredModal } from "../CenteredModal";

import styles from "./GalleryModal.module.scss";

export const GalleryModal = ({
    images,
    trigger,
}: Readonly<{
    images: ImageChooserBlockList;
    trigger: React.ReactNode;
}>) => (
    <CenteredModal
        trigger={trigger}
        theme="black"
        panelClassName={styles.panel}
        overlay="medium"
    >
        <header className={styles.header}>
            <Heading slot="title" className={styles.title}>
                {t`Gallery`}
            </Heading>
        </header>
        <ul className={styles.list}>
            {images.map((image, index) => (
                <li key={index} className={styles.item}>
                    <ImageChooserBlock
                        value={image}
                        imageAttrs={{
                            width: image.width,
                            height: image.height,
                        }}
                    />
                </li>
            ))}
        </ul>
    </CenteredModal>
);
